// extracted by mini-css-extract-plugin
export default {"decorations":"Decoration_decorations__IrgUF"};